import { getPeriodStartAndEndDates, getPreviousPeriodStartAndEndDates, getPreviousYearStartAndEndDates } from "@/utils/periods";
import { PeriodName } from "@/models";
import React from "react";

export interface PeriodDates {
    current: {
        startDate: Date;
        endDate: Date;
    };
    previousPeriod: {
        startDate: Date;
        endDate: Date;
    };
    previousYear: {
        startDate: Date;
        endDate: Date;
    };
}

export const usePeriodDates = (selectedYear: number, selectedPeriod: string): PeriodDates => {
    return React.useMemo(() => {
        const period = PeriodName[selectedPeriod as keyof typeof PeriodName];

        const [currentStart, currentEnd] = getPeriodStartAndEndDates(selectedYear, period);

        const [previousPeriodStart, previousPeriodEnd] = getPreviousPeriodStartAndEndDates(selectedYear, period);

        const [previousYearStart, previousYearEnd] = getPreviousYearStartAndEndDates(selectedYear, period);

        return {
            current: {
                startDate: currentStart,
                endDate: currentEnd,
            },
            previousPeriod: {
                startDate: previousPeriodStart,
                endDate: previousPeriodEnd,
            },
            previousYear: {
                startDate: previousYearStart,
                endDate: previousYearEnd,
            },
        };
    }, [selectedYear, selectedPeriod]);
};
